module.exports = {
      id: "scroll-down-usage",
      viewBox: "0 0 13 180",
      url: __webpack_public_path__ + "img/icons.91580017.svg#scroll-down-usage",
      toString: function () {
        return this.url;
      }
    }